import { create } from 'zustand';

interface HeaderConfigStore {
  title: string | null;
  backPath: string | null;
  setHeader: (title: string | null, backPath: string | null) => void;
  reset: () => void;
}

export const useHeaderConfig = create<HeaderConfigStore>((set) => ({
  title: null,
  backPath: null,
  setHeader: (title, backPath): void => {
    set({ title, backPath });
  },
  reset: (): void => {
    set({ title: null, backPath: null });
  },
}));
